export enum ErrorType {
    NotFound,
    ServerError,
    NoPermission,
    UnsupportedBrowser,
}
